import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'

class InstanciaPlaya extends Component {
  render () {
    const {
      cpa,
      turnosPendientes,
      totalCamiones
    } = this.props

    var camionesCircuito
    if (totalCamiones) {
      const camionesCereal = totalCamiones.filter(camiones => camiones.cereal.trim() === cpa.claveCereal.trim())
      if (camionesCereal[0]) {
        camionesCircuito = camionesCereal[0].entrePlayaYCalado + camionesCereal[0].caladosAutorizados + camionesCereal[0].entreCaladoYBruto + camionesCereal[0].entreBrutoYDestare
      } else {
        camionesCircuito = 0
      }
    }

    return (
      <div>
        {!cpa.fechaDeEgresoPlaya && <div>
          <div className='cantidad-turnos-egreso'>
            { turnosPendientes === 1 && <h6 className='texto-info'>Tienes <strong>{turnosPendientes}</strong> camion de {cpa.cereal} adelante.</h6> }
            { turnosPendientes > 1 && <h6 className='texto-info'>Tienes <strong>{turnosPendientes}</strong> camiones de {cpa.cereal} adelante. </h6> }
          </div>
          <div className='cantidad-camiones-circuito'>
            { (camionesCircuito === 1) && <h6 className='texto-info'>Hay <strong>{camionesCircuito}</strong> camión de {cpa.cereal} en el circuito de descarga.</h6> }
            { (camionesCircuito > 1) && <h6 className='texto-info'>Hay <strong>{camionesCircuito}</strong> camiones de {cpa.cereal} en el circuito de descarga.</h6> }
          </div>
        </div>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cerealVolcadoras: state.volcadora.cerealVolcadoras,
  detalle: state.entregadores.detalle,
  totalCamiones: state.camionesIngreso.totalCamionesCereal,
  turnosPendientes: state.camionesIngreso.turnosPendientesPlaya,
  pedidoCamiones: state.camionesIngreso.camionesPedidos
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(InstanciaPlaya)
